import { defineManifest } from "@tc/sdk";
export const manifest = defineManifest({
    id: "signage",
    name: "TV screens",
    version: "0.1.0",
    tier: "addon",
    accent: "brand",
    dependsOn: ["sites"],
    description: "TV screens for the shop or drivers' lounge: today's fuel prices, the weather, news and sport headlines, your messages and adverts, each screen on its own secret link that just needs a browser.",
    permissions: {
        view: "See the TV screens for your sites",
        manage: "Add screens, change what they show, upload adverts",
    },
    grants: { "Head office": ["view", "manage"], "Area manager": ["view"], "Site manager": ["view"] },
    nav: [
        { label: "TV screens", path: "/signage", section: "operations", tab: "Screens", tabIcon: "tv", permission: "view", icon: "broadcast", order: 92, blurb: "What each shop or lounge screen shows: prices, weather, news" },
        { label: "Screen adverts", path: "/signage/adverts", section: "operations", tab: "Screens", tabIcon: "tv", permission: "manage", icon: "image", order: 93, blurb: "Upload adverts and choose which screens show them" },
    ],
});
